module.exports = __webpack_public_path__ + "static/img/huagong.cf9b50e1.png";